import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {useGlobalSetting} from "@/lib/utils";


export default /*@__PURE__*/_defineComponent({
  __name: 'motorTypeSelector',
  props: /*@__PURE__*/_mergeModels({
  prepend_icon: {
    type: String,
    default: '',
    required: false,
  },
}, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props) {


const model = _useModel(__props, "modelValue");

const props = __props

const items = [
  {
    key: "M1S",
    description: "Basis-Motorstarter für kleine bis mittlere Motoren"
  },
  {
    key: "M1S_FB",
    description: "Rückmeldungseinheit für Motorstarter M1S"
  },
  {
    key: "MMD",
    description: "Motor Management Device – zentrale Steuereinheit für Motorfunktionen"
  },
  {
    key: "MMD_HP",
    description: "Motor Management Device mit Hochleistungsfunktionen"
  },
  {
    key: "MMD_P",
    description: "Motor Management Device mit Prozessanbindung"
  },
  {
    key: "MRE",
    description: "Relaisbasierter Motorstarter"
  },
  {
    key: "MRE_FB",
    description: "Rückmeldungseinheit für Motorregelungseinheit MRE"
  },
  {
    key: "MSD",
    description: "Siemens Starter Device – Standard-Motorstarter"
  },
  {
    key: "MSD_FB",
    description: "Rückmeldungseinheit für MSD"
  },
  {
    key: "MSD_PF",
    description: "MSD mit Power Feedback – Leistungsrückmeldung integriert"
  },
  {
    key: "MSS",
    description: "Siemens Soft Starter – für sanftes Hochfahren von Motoren"
  },
  {
    key: "PF",
    description: "Power Feedback – Modul zur Leistungsrückmeldung"
  }
]


return (_ctx: any,_cache: any) => {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createBlock(_component_v_select, {
    modelValue: model.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
    label: "Motortyp",
    items: items,
    "item-title": "key",
    "prepend-icon": props.prepend_icon,
    variant: _unref(useGlobalSetting)().globalTextVariant
  }, {
    item: _withCtx(({ props: itemProps, item }) => [
      _createVNode(_component_v_list_item, _mergeProps(itemProps, {
        subtitle: item.raw.description
      }), null, 16, ["subtitle"])
    ]),
    _: 1
  }, 8, ["modelValue", "prepend-icon", "variant"]))
}
}

})